// extracted by mini-css-extract-plugin
export var infoItem = "_pa-2";
export var title = "_pa-0";
export var value = "_pa-1";